var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-employment-position-helper-components-3-resource-list",staticStyle:{"text-align":"left"}},[_c('JobEmploymentPositionHelperComponents4JobEmploymentPositionResourceItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }